import React from "react";
import './Sidebar.css'
import { Link } from "react-router-dom";

export default function Sidebar() {

    const loginData = JSON.parse(sessionStorage.getItem("loginData"));
    const sessionusertype = loginData?.utype?.usertype;
    return (
        <div className="Sidebar-outermost-container navbar-dark">
            <ul>
                <li>
                    <Link to="/" className="li-div" style={{ textDecoration: "none" }}>
                        <div className="i-div">
                            <i className="fa-solid fa-home"></i>
                        </div>
                        <div className="h-div">Dashboard</div>
                    </Link>
                </li>

                {(sessionusertype === 0 || sessionusertype === 2) &&
                    <li>
                        <Link to="/adduser" className="li-div" style={{ textDecoration: "none" }}>
                            <div className="i-div">
                                <i className="fa-solid fa-user-plus"></i>
                            </div>
                            <div className="h-div">User Management</div>
                        </Link>
                    </li>}



                {sessionusertype === 1 && (
                    <li >
                        <Link to="/apikeygenerate" className="li-div" style={{ textDecoration: "none" }}>
                            <div className="i-div">
                                <i class="fa-solid fa-key"></i>
                            </div>
                            <div className="h-div">New API Key</div>
                        </Link>
                    </li>
                )}

                <li>
                    <Link to="/whitelistedkeyandip" className="li-div" style={{ textDecoration: "none" }}>
                        <div className="i-div">
                            <i class="fa-solid fa-list-check"></i>
                        </div>
                        <div className="h-div" >Whitelisted key/ip</div>
                    </Link>
                </li>

                <li className="li">
                    <div className="li-div">
                        <div className="i-div">
                            <i class="fa-solid fa-magnifying-glass-chart"></i>
                        </div>
                        <div className="h-div">DLT Management</div>
                        <div className="summary-dropdown" style={{ zIndex: "10000000000" }}>
                            <div>
                                <Link to="/senderwhitelist" style={{ textDecoration: "none", color: "#f7f7f9" }}>Sender Whitelisting </Link></div>
                            <div>
                                <Link to="/templatewhitelist" style={{ textDecoration: "none", color: "#f7f7f9" }}>Template Whitelisting </Link></div>
                        </div>
                    </div>

                </li>

                <li className="li">
                    <div className="li-div">
                        <div className="i-div">
                            <i class="fa-solid fa-magnifying-glass-chart"></i>
                        </div>
                        <div className="h-div">Standard Summary</div>
                        <div className="summary-dropdown" style={{ zIndex: "10000000000" }}>
                            <div style={{height:"2rem", fontSize:"0.85rem"}}>
                                <Link to="/datewisesummary" style={{ textDecoration: "none", color: "#f7f7f9" }}>Date Wise Summary </Link></div>
                            <div style={{height:"2rem", fontSize:"0.85rem"}}>
                                <Link to="/usersummary" style={{ textDecoration: "none", color: "#f7f7f9" }}>User Wise Summary </Link></div>
                            <div style={{height:"2rem", fontSize:"0.85rem"}}>
                                <Link to="/sendersummary" style={{ textDecoration: "none", color: "#f7f7f9" }}>Sender Wise Summary </Link>
                            </div>
                        </div>



                    </div>

                </li>

                <li className="li">
                    <div className="li-div">
                        <div className="i-div">
                            <i class="fa-solid fa-magnifying-glass-chart"></i>
                        </div>
                        <div className="h-div">Custom Summary</div>
                        <div className="summary-dropdown" style={{ zIndex: "10000000000" }}>
                            <div>
                                <Link to="/apikeysummary" style={{ textDecoration: "none", color: "#f7f7f9" }}>API-Key Wise Summary </Link></div>
                            <div>
                                <Link to="/errorcodewisesummary" style={{ textDecoration: "none", color: "#f7f7f9" }}>Error Code Wise Summary </Link></div>
                        </div>
                    </div>

                </li>



                <li>
                    <Link to="/detailedreport" className="li-div" style={{ textDecoration: "none" }}>
                        <div className="i-div">
                            <i className="fa-solid fa-circle-info"></i>
                        </div>
                        <div className="h-div">Detailed Report</div>
                    </Link>
                </li>

                {sessionusertype === 1 &&
                    <li >
                        <Link to="/newipwhitelist" className="li-div" style={{ textDecoration: "none" }}>
                            <div className="i-div">
                                <i class="fa-solid fa-laptop"></i>
                            </div>
                            <div className="h-div">New IP Whitelisting</div>
                        </Link>
                    </li>
                }

 <li>
                    <Link to="/creditmanagement" className="li-div" style={{ textDecoration: "none" }}>
                        <div className="i-div">
                            <i className="fa-solid fa-circle-info"></i>
                        </div>
                        <div className="h-div">Credit Management</div>
                    </Link>
                </li>

                {/* {sessionusertype === 0 && <li style={{ visibility: "hidden" }}> </li>} */}
            </ul>
        </div >
    );
}